import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../layout/service/user.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    standalone: true,
    selector: 'app-quiz-list-widget',
    imports: [CommonModule, DialogModule, ButtonModule, RadioButtonModule, FormsModule],
    template: `
    <ng-container *ngFor="let form of forms; let i = index">
        <div class="col-span-12 lg:col-span-6 xl:col-span-4" *ngIf="form.cases?.length > 0">
            <div class="rounded-lg shadow-md mb-0 border border-white " [ngClass]="getBgColor(i)">
                <div class="p-5">
                    <div class="flex justify-between mb-2 ">
                        <div>
                            <span class="block text-black font-bold text-xl mb-4">{{ form.name }}</span>
                        </div>
                        <div
                            class="flex items-center justify-center rounded-full bg-white/40 shadow-md"
                            style="width: 2.5rem; height: 2.5rem"
                        >
                            <i class="pi pi-heart text-black" style="font-size: 1.25rem"></i>
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="bg-white/50 px-5 mb-2 rounded-full w-fit">
                            <div class="text-black py-1 font-bold text-lg mb-2">
                                {{ form.cases?.length || 0 }} Kasus
                            </div>
                        </div>
                        <div class="bg-white/50 py-2 px-3 rounded-full w-fit">
                            <span class="text-black font-bold text-sm flex items-center gap-2">
                                <i class="pi pi-calendar"></i> 
                                {{ form.created_at | date:'short' }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mt-2 bg-white py-2 px-3">
                    <p-button label="Pilih Kasus" severity="contrast" styleClass="w-full !bg-black !py-3 !hover:!bg-gray-800 !text-white !font-bold" (click)="showCasesDialog(form)" icon="pi pi-arrow-right" iconPos="right" />
                </div>
            </div>
        </div>
    </ng-container>

    <p-dialog header="Pilih Kasus" [(visible)]="showDialog" [modal]="true" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false" position="top" (onHide)="selectedCasesForm=null">
        <div *ngIf="selectedCasesForm">
            <div *ngIf="selectedCasesForm.cases?.length > 0; else noCases">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div *ngFor="let c of selectedCasesForm.cases; let idx = index" class="flex items-center mb-3">
                        <p-radiobutton
                            name="caseRadio"
                            [value]="c"
                            [(ngModel)]="selectedCase"
                            [inputId]="'case'+idx" />
                        <label [for]="'case'+idx" class="ml-2">{{ c.name }}</label>
                    </div>
                </div>
                <div class="flex justify-end mt-4">
                    <p-button
                        label="Mulai"
                        icon="pi pi-play"
                        [disabled]="!selectedCase"
                        (click)="onPlayCase(selectedCase)"
                        styleClass="!bg-gradient-to-r !from-[#5B8EEE] !to-[#4DC8DF] !border-[#5B8EEE] hover:!from-[#4a7bdd] hover:!to-[#3bb5c9]" />
                </div>
            </div>
            <ng-template #noCases>
                <div class="text-gray-500">Tidak ada kasus tersedia.</div>
            </ng-template>
        </div>
    </p-dialog>
    `
})
export class QuizListWidget implements OnInit {

    forms: any[] = [];
    showDialog: boolean = false;
    selectedCasesForm: any = null;
    selectedCase: any = null;

    colorVariants = [
        { bg: 'bg-[#DBEDFA] text-white', icon: 'text-white' },
        { bg: 'bg-[#F3DFE3] text-white', icon: 'text-white' },
        { bg: 'bg-[#E1F6E9] text-white', icon: 'text-white' }
    ];

    constructor(
        private userService: UserService,
        private router: Router
    ) { }

    ngOnInit() {
        this.initApi();
        localStorage.removeItem('selected_case');
        localStorage.removeItem('question_history_list');
        localStorage.removeItem('last_form_detail_id');
        localStorage.removeItem('last_form_detail_data');
        localStorage.removeItem('excluded_form_detail_ids');
        localStorage.removeItem('current_question_index');
    }

    async initApi(): Promise<void> {
        try {
            const formFieldRes = await this.userService.getFormField();
            const formCasesRes = await this.userService.getFormCases();
            const allCases = formCasesRes.data;

            this.forms = formFieldRes.data.map((form: any) => {
                if (typeof form.fields === 'string') {
                    try {
                        form.fields = JSON.parse(form.fields);
                    } catch (error) {
                        console.error('Failed to parse fields:', error);
                        form.fields = [];
                    }
                }
                form.cases = allCases.filter((item: any) => item.form_id === form.id);
                return form;
            });
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    }

    showCasesDialog(form: any) {
        this.selectedCasesForm = form;
        this.selectedCase = null;
        this.showDialog = true;
    }

    onPlayCase(selectedCase: any) {
        // Simpan case ke localStorage
        localStorage.setItem('selected_case', JSON.stringify(selectedCase));
        // Redirect ke halaman answer
        this.showDialog = false;
        this.router.navigate(['/app/osce/form/answer']);
    }

    getBgColor(i: number): string {
        return this.colorVariants[i % this.colorVariants.length].bg;
    }

    getIconColor(i: number): string {
        return this.colorVariants[i % this.colorVariants.length].icon + ' !text-xl';
    }
}
